
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, from, map, of, switchMap } from 'rxjs';
import { IFormStatus, LGEDataService } from '../../../commons';
import {
  FormStatusActionTypes,
  LoadFormStatusStateFail,

  LoadOpenFormCGState,
  LoadClosedFormCGState,
  LoadOpenFormCGStateSuccess,
  LoadClosedFormCGStateSuccess,

  LoadOpenFormPPState,
  LoadOpenFormPPStateSuccess,
  LoadClosedFormPPState,
  LoadClosedFormPPStateSuccess,

  LoadOpenFormESState,
  LoadClosedFormESState,
  LoadOpenFormESStateSuccess,
  LoadClosedFormESStateSuccess,

  CloseRequest,
  ComposeEmail

} from './form-status.actions';

@Injectable()
export class FormStatusEffects {

  constructor(
    private actions$: Actions,
    private lgeData: LGEDataService
  ) { }

  // formCG
  loadOpenCGData$ = createEffect(
    () => this.actions$.pipe(
      ofType(FormStatusActionTypes.LoadOpenFormCGState),
      switchMap(
        () => this.lgeData.GetOpenRequests('CG')
      ),
      switchMap(
        (state: IFormStatus) => [new LoadOpenFormCGStateSuccess(state), new LoadClosedFormCGState()]
      ),
      catchError(error => of(new LoadFormStatusStateFail(error)))
    )
  )

  loadClosedCGData$ = createEffect(
    () => this.actions$.pipe(
      ofType(FormStatusActionTypes.LoadClosedFormCGState),
      switchMap(
        () => from(this.lgeData.GetClosedRequests('CG')).pipe(
          map((state: IFormStatus) => new LoadClosedFormCGStateSuccess(state)),
          catchError(error => of(new LoadFormStatusStateFail(error)))
        )
      )
    )
  )

  // formPP
  loadOpenPPData$ = createEffect(
    () => this.actions$.pipe(
      ofType(FormStatusActionTypes.LoadOpenFormPPState),
      switchMap(
        () => this.lgeData.GetOpenRequests('PP')
      ),
      switchMap(
        (state: IFormStatus) => [new LoadOpenFormPPStateSuccess(state), new LoadClosedFormPPState()]
      ),
      catchError(error => of(new LoadFormStatusStateFail(error)))
    )
  )

  loadClosedPPData$ = createEffect(
    () => this.actions$.pipe(
      ofType(FormStatusActionTypes.LoadClosedFormPPState),
      switchMap(
        () => from(this.lgeData.GetClosedRequests('PP')).pipe(
          map((state: IFormStatus) => new LoadClosedFormPPStateSuccess(state)),
          catchError(error => of(new LoadFormStatusStateFail(error)))
        )
      )
    )
  )

  // formES
  loadOpenESData$ = createEffect(
    () => this.actions$.pipe(
      ofType(FormStatusActionTypes.LoadOpenFormESState),
      switchMap(
        () => this.lgeData.GetOpenRequests('ES')
      ),
      switchMap(
        (state: IFormStatus) => [new LoadOpenFormESStateSuccess(state), new LoadClosedFormESState()]
      ),
      catchError(error => of(new LoadFormStatusStateFail(error)))
    )
  )

  loadClosedESData$ = createEffect(
    () => this.actions$.pipe(
      ofType(FormStatusActionTypes.LoadClosedFormESState),
      switchMap(
        () => from(this.lgeData.GetClosedRequests('ES')).pipe(
          map((state: IFormStatus) => new LoadClosedFormESStateSuccess(state)),
          catchError(error => of(new LoadFormStatusStateFail(error)))
        )
      )
    )
  )

  // other
  closeRequest$ = createEffect(
    () => this.actions$.pipe(
      ofType(FormStatusActionTypes.CloseRequest),
      map((action: CloseRequest) => action.data),
      exhaustMap(
        (data) => from(this.lgeData.UpdateFormStatus_Close(data)).pipe(
          map(
            (state: IFormStatus) => {
              switch (data[0].grantName) {
                case 'PP':
                  return new LoadOpenFormPPState();
                case 'ES':
                  return new LoadOpenFormESState();
                case 'CG':
                default:
                  return new LoadOpenFormCGState();

              }
            }
          ),
          catchError(error => of(new LoadFormStatusStateFail(error)))
        )
      )
    )
  )

  composeEmail$ = createEffect(
    () => this.actions$.pipe(
      ofType(FormStatusActionTypes.ComposeEmail),
      map((action: ComposeEmail) => action.data),
      exhaustMap(
        (data) => from(this.lgeData.SendAwardDeclineEmail(data)).pipe(
          map(
            (state: IFormStatus) => {
              switch (data.requestList[0].grantName) {
                case 'PP':
                  return new LoadClosedFormPPState();
                case 'ES':
                  return new LoadClosedFormESState();
                case 'CG':
                default:
                  return new LoadClosedFormCGState();

              }
            }
          ),
          catchError(error => of(new LoadFormStatusStateFail(error)))
        )
      )
    )
  )
}




// LoadOpenFormCIState,
// LoadOpenFormCIStateSuccess,
// LoadClosedFormCIStateSuccess,
// LoadClosedFormCIState,
// LoadOpenFormFOState,
// LoadOpenFormFOStateSuccess,
// LoadClosedFormFOState,
// LoadClosedFormFOStateSuccess,


// @Effect()
// loadOpenCIData$: Observable < Action > = this.actions$
//   .ofType(FormStatusActionTypes.LoadOpenFormCIState)
//   .switchMap(() =>
//     // You can pull from offline state here or get data from a server via an api
//     // An example of inserting data into offline state can be found in login.effects.ts
//     Observable.fromPromise(this.lgeData.GetOpenRequests('CI'))
//       .mergeMap((state: IFormStatus) => [new LoadOpenFormCIStateSuccess(state), new LoadClosedFormCIState()])
//       .catch(error => Observable.of(new LoadFormStatusStateFail(error)))
//   );
// @Effect()
// loadClosedCIData$: Observable < Action > = this.actions$
//   .ofType(FormStatusActionTypes.LoadClosedFormCIState)
//   .switchMap(() =>
//     // You can pull from offline state here or get data from a server via an api
//     // An example of inserting data into offline state can be found in login.effects.ts
//     Observable.fromPromise(this.lgeData.GetClosedRequests('CI'))
//       .map((state: IFormStatus) => new LoadClosedFormCIStateSuccess(state))
//       .catch(error => Observable.of(new LoadFormStatusStateFail(error)))
//   );

// @Effect()
// loadOpenFOData$: Observable < Action > = this.actions$
//   .ofType(FormStatusActionTypes.LoadOpenFormFOState)
//   .switchMap(() =>
//     // You can pull from offline state here or get data from a server via an api
//     // An example of inserting data into offline state can be found in login.effects.ts
//     Observable.fromPromise(this.lgeData.GetOpenRequests('FO'))
//       .mergeMap((state: IFormStatus) => [new LoadOpenFormFOStateSuccess(state), new LoadClosedFormFOState()])
//       .catch(error => Observable.of(new LoadFormStatusStateFail(error)))
//   );
// @Effect()
// loadClosedFOData$: Observable < Action > = this.actions$
//   .ofType(FormStatusActionTypes.LoadClosedFormFOState)
//   .switchMap(() =>
//     // You can pull from offline state here or get data from a server via an api
//     // An example of inserting data into offline state can be found in login.effects.ts
//     Observable.fromPromise(this.lgeData.GetClosedRequests('FO'))
//       .map((state: IFormStatus) => new LoadClosedFormFOStateSuccess(state))
//       .catch(error => Observable.of(new LoadFormStatusStateFail(error)))
//   );